module.exports = __webpack_public_path__ + "img/ltkeurope-2x.7c148f3.jpg";